import { render, staticRenderFns } from "./AuthRegisterForm.vue?vue&type=template&id=3bcf158a&scoped=true&lang=pug&"
import script from "./AuthRegisterForm.vue?vue&type=script&lang=js&"
export * from "./AuthRegisterForm.vue?vue&type=script&lang=js&"
import style0 from "./AuthRegisterForm.vue?vue&type=style&index=0&id=3bcf158a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcf158a",
  null
  
)

export default component.exports